export default __webpack_public_path__ + "media/images/features/hida/hero-f094095df5b69c1179506c0469d39893.png";